import React, { useState, useEffect } from 'react';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { wsGetAll } from 'services/WService';
import Modal from 'components/Tvendo/Common/ModalBase';
import styles from 'assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js';
import { makeStyles } from '@material-ui/core/styles';
import SweetAlert from 'react-bootstrap-sweetalert';
import { onlyInteger } from 'hooks/Pipe';
import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';

const useStyles = makeStyles(styles);

export default function ModalDistributionStaff(props) {
  const classes = useStyles();

  const dStaff = props.model;
  const [dataChanging, setDataChanging] = useState(dStaff);
  const [alert, setAlert] = useState(null);
  function messageResponse(response) {
    if (!response.data.password) {
      return setAlert(null);
    }
    setAlert(
      <SweetAlert
        style={{ display: 'block', marginTop: '-100px' }}
        title={`Usuario: ${response.data?.user.email} // Clave: ${response.data?.password}`}
        onConfirm={() => {
          setAlert(null);
          props.reload();
        }}
        onCancel={() => setAlert(null)}
        confirmBtnCssClass={classes.button + ' ' + classes.success}
      />,
    );
  }

  function handleChange(field, value) {
    setDataChanging({ ...dataChanging, [field]: value });
  }

  return (
    <>
      {alert}
      <Modal
        title="Choferes publicos"
        model={dStaff}
        setOpen={props.setOpen}
        showNotify={props.showNotify}
        reload={props.reload}
        dataChanging={dataChanging}
        setDataChanging={setDataChanging}
        entity="prog/public-distribution-staff"
        responseData={messageResponse}
        maxWidth={'md'}
      >
        <GridContainer>
          {/* Codigo (Dni) */}
          <GridItem xs={12} sm={6}>
            <TextField
              label="Código (Dni)"
              fullWidth
              name="code"
              margin="normal"
              defaultValue={!!dStaff ? dStaff.code : ''}
              required
            />
          </GridItem>
          {/* Celular */}
          <GridItem xs={12} sm={6}>
            <TextField
              label="Celular"
              fullWidth
              name="phone"
              margin="normal"
              defaultValue={!!dStaff ? dStaff.phone : ''}
              onKeyPress={onlyInteger}
              inputProps={{ minLength: 9, maxLength: 9 }}
              required
            />
          </GridItem>

          {/* Nombre completo */}
          <GridItem xs={12}>
            <TextField
              label="Nombre completo"
              fullWidth
              name="name"
              margin="normal"
              defaultValue={!!dStaff ? dStaff.name : ''}
              required
            />
          </GridItem>
          {/* FirstName */}
          <GridItem xs={12} sm={6}>
            <TextField
              label="Nombres"
              fullWidth
              name="FirstName"
              margin="normal"
              defaultValue={!!dStaff ? dStaff.FirstName : ''}
              required
            />
          </GridItem>
          {/* LastName */}
          <GridItem xs={12} sm={6}>
            <TextField
              label="Apellidos"
              fullWidth
              name="LastName"
              margin="normal"
              defaultValue={!!dStaff ? dStaff.LastName : ''}
              required
            />
          </GridItem>

          <GridItem xs={12}>
            <TextField
              label="Licencia de conducir"
              fullWidth
              name="driver_license"
              margin="normal"
              defaultValue={!!dStaff ? dStaff.driver_license : ''}
              required
            />
          </GridItem>
        </GridContainer>
      </Modal>
    </>
  );
}
